// extracted by mini-css-extract-plugin
export default {"divider":"CaseFormButtonContainer_divider__12K4O","buttonContainer":"CaseFormButtonContainer_buttonContainer__RzedA"};